import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary]", error, errorInfo);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", padding: "24px", fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif", color: "#1A1A1A", background: "#FAFBFA" }}>
        <h1 style={{ fontSize: "1.25rem", fontWeight: 700, marginBottom: 8 }}>Something went wrong</h1>
        <p style={{ fontSize: "0.875rem", color: "#78716C", marginBottom: 20, textAlign: "center" }}>An unexpected error occurred. Please reload to continue.</p>
        <button
          onClick={() => window.location.reload()}
          style={{ padding: "10px 24px", borderRadius: 12, border: "none", background: "#4E7A67", color: "#fff", fontSize: "0.875rem", fontWeight: 600, cursor: "pointer" }}
        >
          Reload App
        </button>
      </div>
    );
  }
}
